export function colorInnerSvgPaths(svgData: string, color: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(svgData, 'text/html')
  const elementsWithFillAttribute: SVGPathElement[] = Array.from(
    doc.querySelectorAll('path')
  )

  for (const element of elementsWithFillAttribute) {
    element.setAttribute('fill', color)
    element.style.cssText = `${element.style.cssText}; fill: ${color} !important;`
  }

  return doc.documentElement.innerHTML
}
